<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <div class="row mb">
      <div class="col-sm-12 col-xs-12 col-md-12">
        <pr-input-column
          label="Évaluation de vos revenus nets annuels."
          [derrors]="derrors"
          [isDefault]="false"
          [suffix]="'€/an'"
        >
          <input notdot formControlName="amount" type="text" />
        </pr-input-column>
      </div>
    </div>

    <div class="row row-table">
      <div class="col-md-12">
        <pr-panel
          ><div class="man pr-panel">
            <pr-panel-body
              ><div class="pr-panel-body undefined">
                <div
                  class="pr-card-swiper animated fadeIn relative overflow-hidden"
                >
                  <table class="pr-table-card-container" style="width: 100%">
                    <tbody class="pr-table-card-statistics-body">
                      <ng-container>
                        <div class="pr-table-card-row ng-star-inserted">
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >Salaires ou pensions</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('salaryOrRetirement')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >Bénéfices fonciers</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('propertyIncome')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>

                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >Bénéfices BIC</span
                                >
                              </div>
                            </div>
                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('bicIncome')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis"
                                  >Bénéfices mobiliers</span
                                >
                              </div>
                            </div>

                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('movableIncome')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis">
                                  Bénéfices BNC
                                </span>
                              </div>
                            </div>
                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('bncIncome')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="pointer pr-table-card-row-container">
                            <div
                              class="pr-table-card-cell grid-span-4 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="d-flex ng-star-inserted"
                                style="max-width: 500px"
                              >
                                <span class="ng-star-inserted text-ellipsis">
                                  Bénéfices BA
                                </span>
                              </div>
                            </div>
                            <div
                              class="pr-table-card-cell grid-span-1 ng-star-inserted text-ellipsis"
                            >
                              <div
                                class="ng-star-inserted"
                                style="max-width: 300px"
                                [formGroup]="form.get('baIncome')"
                              >
                                <span class="ng-star-inserted">
                                  <input
                                    notdot
                                    class="full-w percent"
                                    formControlName="percent"
                                  /> </span
                                ><span
                                  style="margin-left: 3px"
                                  class="ng-star-inserted"
                                  >%</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div></pr-panel-body
            >
          </div>
        </pr-panel>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <pr-color-panel [display]="allocationPanel(totalAllocated)?.display">
          <pr-panel-body clazz="pam">
            <pr-label
              [name]="allocationPanel(totalAllocated)?.icon"
              [width]="18"
              [height]="18"
              >{{ allocationPanel(totalAllocated)?.text }}</pr-label
            >
          </pr-panel-body>
        </pr-color-panel>
      </div>
    </div>
    <div class="row mb">
      <div class="col col-md-12">
        <pr-input-column
          label="Parts fiscales"
          [derrors]="derrors"
          [isDefault]="false"
        >
          <input notdot formControlName="taxShareNumber" type="text" />
        </pr-input-column>
      </div>
    </div>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
@if (loading) {
  <pr-loader></pr-loader>
}
